import { z } from 'zod';

export const appRoleSchema = z.enum([
  'Neighbourhood',
  'Neighbourhood_Manager',
  'PCFRA_Editor',
  'PCFRA_Manager',
  'Admin',
]);

export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  camdenAccountName: z.string(),
  name: z.string(),
  roles: appRoleSchema.array(),
  sessionExpires: z.string().optional(),
});
